var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-main" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            collapse: _vm.getIsOpenCloseManu,
            "background-color": "#f8fbff",
            "text-color": "#5f6f8f",
            "active-text-color": "#2f436d",
            "unique-opened": true,
            "default-active": _vm.activeMenuIndex,
            "default-openeds": _vm.openSubMenu,
          },
          on: { select: _vm.handleMenuSelect },
        },
        [
          _c(
            "router-link",
            { staticClass: "router-link", attrs: { to: "/dashboard" } },
            [
              _c(
                "el-menu-item",
                { staticClass: "menu-logo-item", attrs: { index: "1" } },
                [
                  _c("i", { staticClass: "el-icon-s-home menu-logo-icon" }),
                  _c(
                    "span",
                    {
                      staticClass: "onekids-title",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [_vm._v("ONEKIDS PLUS")]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.checkPermission(["news"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-news",
                  attrs: { index: "2" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-notebook-2" }),
                            _c("span", { staticClass: "title_nav" }, [
                              _vm._v("\n          Bảng tin\n          "),
                              _vm.parentFeedback > 0 || _vm.teacherFeedback > 0
                                ? _c("span", {
                                    staticClass: "title_nav_indicator",
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3381176683
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/appsend/notification" },
                    },
                    [
                      _vm.checkPermission(["news_notifySystem"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "appsend-notification"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thông báo hệ thống\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/notifihis/notify-school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "notifihis-notify-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Tin tức nhà trường\n        ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/appsend/parent-feedback" },
                    },
                    [
                      _vm.checkPermission(["news_feedbackParent"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "appsend-parent-feedback"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Phụ huynh góp ý")]),
                                _vm.parentFeedback > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.parentFeedback))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/appsend/teacher-feedback" },
                    },
                    [
                      _vm.checkPermission(["news_feedbackTeacher"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "appsend-teacher-feedback"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Giáo viên góp ý")]),
                                _vm.teacherFeedback > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.teacherFeedback))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/survey_form/manager" },
                    },
                    [
                      _vm.checkPermission(["news_survey"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "survey-form-manager"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          Phiếu khảo sát\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-diary",
              attrs: { index: "3" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-reading" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Nhật ký phụ huynh\n          "),
                        _vm.parentMessage > 0 ||
                        _vm.medicationInstructions > 0 ||
                        _vm.leaveStudent > 0
                          ? _c("span", { staticClass: "title_nav_indicator" })
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/message-parent" },
                },
                [
                  _vm.checkPermission(["parentDiary_message"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "3-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-message-parent"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Lời nhắn")]),
                            _vm.parentMessage > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.parentMessage)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/medicine" },
                },
                [
                  _vm.checkPermission(["parentDiary_medicine"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "3-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-medicine"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Dặn thuốc")]),
                            _vm.medicationInstructions > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.medicationInstructions)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/take-leave" },
                },
                [
                  _vm.checkPermission(["parentDiary_absenLetter"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "3-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-take-leave"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Xin nghỉ")]),
                            _vm.leaveStudent > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.leaveStudent)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/absent_letter/daily" },
                },
                [
                  _vm.checkPermission(["absent_letter_v4"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "3-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "absent-letter_v4"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Xin nghỉ")]),
                            _vm.leaveStudent > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.leaveStudent)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-staff",
              attrs: { index: "4" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-user" }),
                      _c("span", [_vm._v("Quản lý nhân sự")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/employee/department" },
                },
                [
                  _vm.checkPermission(["infoEmployee_department"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "employee-department"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách phòng ban\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/employee/employees" },
                },
                [
                  _vm.checkPermission(["infoEmployee_list"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "employee-employees"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách nhân sự\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-student",
              attrs: { index: "5" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-user-solid" }),
                      _c("span", [_vm._v("Quản lý học sinh")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                { staticClass: "router-link", attrs: { to: "/student/grade" } },
                [
                  _vm.checkPermission(["kids_grade"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod("student-grade")
                            },
                          },
                        },
                        [_vm._v("Danh sách khối\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                { staticClass: "router-link", attrs: { to: "/student/class" } },
                [
                  _vm.checkPermission(["kids_class"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod("student-class")
                            },
                          },
                        },
                        [_vm._v("Danh sách lớp\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student/students" },
                },
                [
                  _vm.checkPermission(["kids_list"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-students"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách học sinh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parent/manager" },
                },
                [
                  _vm.checkPermission(["kids_list"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parent_manager"
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Danh sách phụ huynh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student/students-group" },
                },
                [
                  _vm.checkPermission(["kids_group"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-students-group"
                              )
                            },
                          },
                        },
                        [_vm._v("Nhóm học sinh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.checkPermission(["kids_transfer"])
                ? _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student/students-transfer" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "5-6" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-students-transfer"
                              )
                            },
                          },
                        },
                        [_vm._v("Thông tin mở rộng\n        ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-quality",
              attrs: { index: "6" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-document-checked" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Chất lượng học sinh\n          "),
                        _vm.commentStudent > 0 ||
                        _vm.pictureAlbum > 0 ||
                        _vm.heightWeight > 0
                          ? _c("span", { staticClass: "title_nav_indicator" })
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/attendance" },
                },
                [
                  _vm.checkPermission(["studentQuality_attendance"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-attendance"
                              )
                            },
                          },
                        },
                        [_vm._v("Điểm danh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/attendance/v2" },
                },
                [
                  _vm.checkPermission(["studentQuality_attendance_v2"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-attendance_v2"
                              )
                            },
                          },
                        },
                        [_vm._v("Điểm danh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/attendance/daily" },
                },
                [
                  _vm.checkPermission(["attendance_v4"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod("attendance-v4")
                            },
                          },
                        },
                        [_vm._v("Điểm danh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/attendance-class-v3" },
                },
                [
                  _vm.checkPermission(["attendance-class-v3"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "attendance-class-v3"
                              )
                            },
                          },
                        },
                        [_vm._v("Điểm danh theo lớp\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/attendance-group-v3" },
                },
                [
                  _vm.checkPermission(["attendance-group-v3"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "attendance-group-v3"
                              )
                            },
                          },
                        },
                        [_vm._v("Điểm danh theo nhóm\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/evaluate" },
                },
                [
                  _vm.checkPermission(["studentQuality_evaluate"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-6" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-evaluate"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Nhận xét")]),
                            _vm.commentStudent > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.commentStudent)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                { staticClass: "router-link", attrs: { to: "/evaluation-v4" } },
                [
                  _vm.checkPermission(["student-evaluation-v4"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-7" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-evaluation-v4"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Nhận xét")]),
                            _vm.commentStudent > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.commentStudent)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                { staticClass: "router-link", attrs: { to: "/album-v2" } },
                [
                  _vm.checkPermission(["studentQuality_ablum"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-8" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-album"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Album ảnh")]),
                            _vm.pictureAlbum > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.pictureAlbum)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/height-weight" },
                },
                [
                  _vm.checkPermission(["studentQuality_heightWeight"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-9" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-height-weight"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Chiều cao, cân nặng")]),
                            _vm.heightWeight > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.heightWeight)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/schedule" },
                },
                [
                  _vm.checkPermission(["studentQuality_schedule"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-10" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-schedule"
                              )
                            },
                          },
                        },
                        [_vm._v("Thời khóa biểu\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/class-menu" },
                },
                [
                  _vm.checkPermission(["studentQuality_menu"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-11" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-class-menu"
                              )
                            },
                          },
                        },
                        [_vm._v("Thực đơn\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/student-quality/lifecycle" },
                },
                [
                  _vm.checkPermission(["studentQuality_lifecycle", "kids_list"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "6-12" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "student-quality-lifecycle"
                              )
                            },
                          },
                        },
                        [_vm._v("Lịch sử học sinh\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["fees"]) &
          (_vm.checkPermission(["fees_order"]) ||
            _vm.checkPermission(["fees_2_excel"]))
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-fees",
                  attrs: { index: "8" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-money" }),
                            _c("span", { staticClass: "title_nav" }, [
                              _vm._v(
                                "\n          Học phí & dịch vụ\n          "
                              ),
                              _vm.tuitionClass > 0 || _vm.tuitionGroup > 0
                                ? _c("span", {
                                    staticClass: "title_nav_indicator",
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    60109925
                  ),
                },
                [
                  _vm.checkPermission(["fees_order"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/order" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-order"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thu học phí\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_approved_advance"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/approved/advance" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-approved-advance"
                                  )
                                },
                              },
                            },
                            [_vm._v("Duyệt nâng cao\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_approved"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/approved" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-approved"
                                  )
                                },
                              },
                            },
                            [_vm._v("Duyệt học phí\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_kidsPackage"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/package-kids" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-package-kids"
                                  )
                                },
                              },
                            },
                            [_vm._v("Đăng ký khoản\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_package"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/package" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-package"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách khoản\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_wallet"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finace/fees/wallet" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finace-fees-wallet"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý ví\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_excel"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finance/v2" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-fees-order-excel"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Thu học phí theo lớp")]),
                                _vm.tuitionClass > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.tuitionClass))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_group"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finance/tuition-group-by-excel" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-fees-order-excel-group"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Thu học phí theo nhóm")]),
                                _vm.tuitionGroup > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.tuitionGroup))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_excel"])
                    ? _c(
                        "el-submenu",
                        {
                          attrs: { index: "8-19" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [_vm._v("Khởi tạo học phí")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2058725825
                          ),
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/finance/manage/initialize-class-tuition",
                              },
                            },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "8-9-1" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeBreadcrumbMethod(
                                        "finance-manage-initialize-class-tuition"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Duyệt khoản học phí lớp\n          ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/finance/manage/initialize-group-tuition",
                              },
                            },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "8-9-2" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeBreadcrumbMethod(
                                        "finance-manage-initialize-group-tuition"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Duyệt khoản học phí nhóm\n          ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/finance/manage/register-revenue" },
                            },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "8-9-3" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeBreadcrumbMethod(
                                        "finance-manage-register-revenue"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Đăng ký khoản\n          ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/finance/manage/tuition-management",
                              },
                            },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "8-9-4" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeBreadcrumbMethod(
                                        "finance-manage-tuition-management"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Danh sách khoản\n          ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_finance_tuition_statistics"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finance/tuition-statistics" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-10" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-tuition-statistics"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thống kê học phí\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_finance_tuition_statistics"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finance/tuition-statistics/charts" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-11" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-tuition-statistics-charts"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          Biểu đồ thống kê\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["fees_2_manager_tuition"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/finance/manage/packages" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-12" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-packages"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          Quản lý học phí gói\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["tuition_fees_services_v4"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-fees",
                  attrs: { index: "20" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-money" }),
                            _c("span", { staticClass: "title_nav" }, [
                              _vm._v(
                                "\n          Học phí & dịch vụ\n          "
                              ),
                              _vm.tuitionV4 > 0
                                ? _c(
                                    "span",
                                    { staticClass: "title_nav_indicator" },
                                    [
                                      _c("span", {
                                        staticClass: "hue_dot_notification",
                                      }),
                                      _c("span", {
                                        staticClass: "dot_notification",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3913671917
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/student-invoices" },
                    },
                    [
                      _vm.checkPermission(["tuition_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-student-invoices"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Thu học phí")]),
                                _vm.tuitionV4 > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.tuitionV4))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/draft-invoice" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-draft-invoice"
                                  )
                                },
                              },
                            },
                            [_vm._v("Duyệt học phí\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/managing-revenue" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-managing-revenue"
                                  )
                                },
                              },
                            },
                            [_vm._v("Đăng ký khoản sử dụng\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/revenue-scopes" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-revenue-scopes"
                                  )
                                },
                              },
                            },
                            [_vm._v("Đăng ký  lớp/nhóm/gói\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/total-revenues" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-total-revenues"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách khoản chính\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/principal-revenues" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"]) &&
                      _vm.checkPermission(["initialize-sub-account"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-principal-revenues"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách khoản phụ\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/packages" },
                    },
                    [
                      _vm.checkPermission(["tuition_manage_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-packages"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách gói học phí\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/finance/manage-v3/tuition-statistics" },
                    },
                    [
                      _vm.checkPermission(["tuition_statistics_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-tuition-statistics"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thống kê phiếu thu\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/finance/manage-v3/tuition-statistics/charts",
                      },
                    },
                    [
                      _vm.checkPermission(["tuition_chart_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-9" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-tuition-statistics-charts"
                                  )
                                },
                              },
                            },
                            [_vm._v("Biểu đồ thống kê\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/finance/manage-v3/student-invoice-summary",
                      },
                    },
                    [
                      _vm.checkPermission(["tuition_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "20-10" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "finance-manage-v3-student-invoice-summary"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tổng hợp phiếu thu\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-salary",
              attrs: { index: "9" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-coin" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Công lương\n          "),
                        _vm.payroll > 0
                          ? _c("span", { staticClass: "title_nav_indicator" })
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/paid" },
                },
                [
                  _vm.checkPermission(["salary_order"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-paid"
                              )
                            },
                          },
                        },
                        [_vm._v("Thanh toán lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/approved" },
                },
                [
                  _vm.checkPermission(["salary_approved"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-approved"
                              )
                            },
                          },
                        },
                        [_vm._v("Duyệt bảng lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/institute" },
                },
                [
                  _vm.checkPermission(["salary_setting"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-institute"
                              )
                            },
                          },
                        },
                        [_vm._v("Thiết lập tiền lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/sample" },
                },
                [
                  _vm.checkPermission(["salary_sample"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-sample"
                              )
                            },
                          },
                        },
                        [_vm._v("Mẫu công lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finance/employee/salary/new" },
                },
                [
                  _vm.checkPermission(["salary_new_excel"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finance-employee-salary-new"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Bảng lương")]),
                            _vm.payroll > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.payroll)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finance/salary/statistical" },
                },
                [
                  _vm.checkPermission(["salary_new_excel_statistics"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-6" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finance-salary-statistical"
                              )
                            },
                          },
                        },
                        [_vm._v("Thống kê công lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finance/employee/static-salary/new" },
                },
                [
                  _vm.checkPermission(["salary_new_excel_chart_view"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-7" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finance-employee-static-salary-new"
                              )
                            },
                          },
                        },
                        [_vm._v("Biểu đồ công lương\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-attendance",
              attrs: { index: "10" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-document-checked" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Chấm công\n          "),
                        _vm.leavePersonnel > 0
                          ? _c("span", { staticClass: "title_nav_indicator" })
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/absent" },
                },
                [
                  _vm.checkPermission(["attendanceEmployee_absentTeacher"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-absent"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Xin nghỉ nhân sự")]),
                            _vm.leavePersonnel > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.leavePersonnel)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/attendance" },
                },
                [
                  _vm.checkPermission(["attendanceEmployee_attendance"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-attendance"
                              )
                            },
                          },
                        },
                        [_vm._v("Chấm công nhân viên\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/attendance-employee-v3" },
                },
                [
                  _vm.checkPermission(["attendance-employee-v3"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "attendance-employee-v3"
                              )
                            },
                          },
                        },
                        [_vm._v("Chấm công nhân viên\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/salary/attendance-config" },
                },
                [
                  _vm.checkPermission(["attendanceEmployee_config"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-salary-attendance-config"
                              )
                            },
                          },
                        },
                        [_vm._v("Thiết lập chấm công\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-cash",
              attrs: { index: "11" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-suitcase-1" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Thu chi nội bộ\n          "),
                        _vm.paymentVouchers > 0 || _vm.receipts > 0
                          ? _c("span", { staticClass: "title_nav_indicator" })
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/cashinternal/paymoney" },
                },
                [
                  _vm.checkPermission(["cashInternal_out"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-cashinternal-paymoney"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Quản lý phiếu chi")]),
                            _vm.paymentVouchers > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.paymentVouchers)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/cashinternal/collectmoney" },
                },
                [
                  _vm.checkPermission(["cashInternal_in"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-cashinternal-collectmoney"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Quản lý phiếu thu")]),
                            _vm.receipts > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.receipts)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/cashinternal/cashbook" },
                },
                [
                  _vm.checkPermission(["cashInternal_cashbook"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-cashinternal-cashbook"
                              )
                            },
                          },
                        },
                        [_vm._v("Quản lý quỹ\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/cashinternal/peopletype" },
                },
                [
                  _vm.checkPermission(["cashInternal_people"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-cashinternal-peopletype"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách đối tượng\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/finace/cashinternal/bankinfo" },
                },
                [
                  _vm.checkPermission(["cashInternal_bank"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "finace-cashinternal-bankinfo"
                              )
                            },
                          },
                        },
                        [_vm._v("Thông tin thanh toán\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["electronic-invoice"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-invoice",
                  attrs: { index: "12" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-s-order" }),
                            _c("span", [_vm._v("Hóa đơn điện tử")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3560939014
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/customer-information" },
                    },
                    [
                      _vm.checkPermission(["electronic invoice-config"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "sinvoice-customer-information"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          Cấu hình S-Invoice\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/export-by-class" },
                    },
                    [
                      _vm.checkPermission(["electronic-invoice-class"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "sinvoice-export-by-class"
                                  )
                                },
                              },
                            },
                            [_vm._v("Xuất hóa đơn theo lớp\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/export-by-group" },
                    },
                    [
                      _vm.checkPermission(["electronic-invoice-group"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "sinvoice-export-by-group"
                                  )
                                },
                              },
                            },
                            [_vm._v("Xuất hóa đơn theo nhóm\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/invoice-management" },
                    },
                    [
                      _vm.checkPermission(["invoice-management"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "invoice-management"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý hóa đơn học phí\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/invoice-management-other" },
                    },
                    [
                      _vm.checkPermission(["invoice-management"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "invoice-management-other"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý hóa đơn khác\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/sinvoice/goods-services" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "12-6" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "sinvoice-goods-services"
                              )
                            },
                          },
                        },
                        [_vm._v("Hàng hóa, dịch vụ\n        ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "router-link",
                      staticStyle: { color: "#bfcbd9", display: "block" },
                      attrs: {
                        href: "https://vinvoice.viettel.vn/account/login",
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _vm.checkPermission(["electronic invoice-support"])
                        ? _c("el-menu-item", { attrs: { index: "12-7" } }, [
                            _vm._v("S-InVoice\n        "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["bank-connection-manager"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-banking",
                  attrs: { index: "13" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-money" }),
                            _c("span", [_vm._v("Thanh toán trực tuyến")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4179277784
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/school/bank-connection-manager/v2" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "13-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "school-bank-connection-manager-v2"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Danh sách ngân hàng liên kết\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/school/bank-transaction-statistics-school",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "13-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "school-bank-transaction-statistics-school"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Thống kê lịch sử giao dịch\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/school/transaction-volume-chart-school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "13-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "school-transaction-volume-chart-school"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Thống kê số lượng giao dịch\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/school/student-user-statistics" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "13-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "school-student-user-statistics"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Danh sách học sinh sử dụng\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["statistical"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-chart",
                  attrs: { index: "14" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-s-data" }),
                            _c("span", [_vm._v("Thống kê")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1575810609
                  ),
                },
                [
                  _vm.checkPermission(["statistical_kids"])
                    ? _c(
                        "el-submenu",
                        {
                          attrs: { index: "14-1" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [_vm._v("Học sinh")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            416177959
                          ),
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/chart-status" },
                            },
                            [
                              _vm.checkPermission(["statistical_kids_status"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-1-1" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-status"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Trạng thái\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/attendance" },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_kids_attendance",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-1-2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-attendance"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Điểm danh\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/evaluate" },
                            },
                            [
                              _vm.checkPermission(["statistical_kids_evaluate"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-1-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-evaluate"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Nhận xét\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/album" },
                            },
                            [
                              _vm.checkPermission(["statistical_kids_album"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-1-4" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-album"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Album ảnh\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/fees" },
                            },
                            [
                              _vm.checkPermission(["statistical_kids_fees"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-1-5" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-fees"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Học phí\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["statistical_employee"])
                    ? _c(
                        "el-submenu",
                        {
                          attrs: { index: "14-2" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [_vm._v("Nhân sự")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2764079733
                          ),
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/chart/statistical/chart-status-employee",
                              },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_employee_status",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-2-1" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-status-employee"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Trạng thái\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/chart/statistical/attendance-employee",
                              },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_employee_attendance",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-2-2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-attendance-employee"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Điểm danh\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/finace" },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_employee_salary",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-2-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-finace"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Công lương\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["statistical_internal"])
                    ? _c(
                        "el-submenu",
                        {
                          attrs: { index: "14-3" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [_vm._v("Nội bộ")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            764385848
                          ),
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/chart/statistical/cashinternal-paymoney",
                              },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_internal_inout",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-3-1" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-cashinternal-paymoney"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Thu chi\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/chart/statistical/cashinternal-cashbook",
                              },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_internal_cashbook",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-3-2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-cashinternal-cashbook"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Quỹ nhà trường\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/chart/statistical/wallet-parent" },
                            },
                            [
                              _vm.checkPermission([
                                "statistical_internal_wallet",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-3-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "chart-statistical-wallet-parent"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Ví phụ huynh\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["statisticalFinance"])
                    ? _c(
                        "el-submenu",
                        {
                          attrs: { index: "14-4" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("span", [_vm._v("Thống kê báo cáo")]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3818753794
                          ),
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/finace/statistical/money" },
                            },
                            [
                              _vm.checkPermission([
                                "statisticalFinance_statistical",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-4-1" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "finace-statistical-money"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Thống kê\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/finace/statistical/finance" },
                            },
                            [
                              _vm.checkPermission(["statisticalFinance_money"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-4-2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "finace-statistical-finance"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Số liệu báo cáo\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: { to: "/finace/statistical/kids/group" },
                            },
                            [
                              _vm.checkPermission([
                                "statisticalFinance_groupFees",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-4-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "finace-statistical-kids-group"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Nhóm học phí\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass: "router-link",
                              attrs: {
                                to: "/finace/statistical/employee/group",
                              },
                            },
                            [
                              _vm.checkPermission([
                                "statisticalFinance_groupSalary",
                              ])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "14-4-4" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeBreadcrumbMethod(
                                            "finace-statistical-employee-group"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Nhóm công lương\n          ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["birthday"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-birthday",
                  attrs: { index: "15" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-burger" }),
                            _c("span", { staticClass: "title_nav" }, [
                              _vm._v(
                                "\n         Quản lý sinh nhật\n          "
                              ),
                              _vm.studentBirthday > 0 ||
                              _vm.parentBirthday > 0 ||
                              _vm.employeeBirthday > 0
                                ? _c("span", {
                                    staticClass: "title_nav_indicator",
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4225417672
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/birthday/kids" },
                    },
                    [
                      _vm.checkPermission(["birthday_kids"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "15-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "birthday-kids"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Sinh nhật học sinh")]),
                                _vm.studentBirthday > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.studentBirthday))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/birthday/parent" },
                    },
                    [
                      _vm.checkPermission(["birthday_parent"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "15-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "birthday-parent"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Sinh nhật phụ huynh")]),
                                _vm.parentBirthday > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.parentBirthday))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/birthday/employee" },
                    },
                    [
                      _vm.checkPermission(["birthday_teacher"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "15-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "birthday-employee"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Sinh nhật nhân viên")]),
                                _vm.employeeBirthday > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.employeeBirthday))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["notifyHistory"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-history",
                  attrs: { index: "16" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-chat-dot-round" }),
                            _c("span", { staticClass: "title_nav" }, [
                              _vm._v(
                                "\n         Lịch sử thông báo\n          "
                              ),
                              _vm.SMSHistory > 0 ||
                              _vm.appNotificationHistory > 0
                                ? _c("span", {
                                    staticClass: "title_nav_indicator",
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    855442843
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/notifihis/schedulesms" },
                    },
                    [
                      _vm.checkPermission(["notifyHistory_schedule"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "16-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "notifihis-schedulesms"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tin nhắn đặt lịch\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/notifihis/custom" },
                    },
                    [
                      _vm.checkPermission(["notifyHistory_custom"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "16-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "notifihis-custom"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tin nhắn tùy chỉnh\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/notifihis/historysms" },
                    },
                    [
                      _vm.checkPermission(["notifyHistory_historySms"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "16-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "notifihis-historysms"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Lịch sử nhắn tin SMS")]),
                                _vm.SMSHistory > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [_vm._v(_vm._s(_vm.SMSHistory))]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/notifihis/historyapp" },
                    },
                    [
                      _vm.checkPermission(["notifyHistory_historyApp"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "16-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "notifihis-historyapp"
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wrap_title_nav" }, [
                                _c("span", [_vm._v("Lịch sử thông báo App")]),
                                _vm.appNotificationHistory > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "notification_nav" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.appNotificationHistory)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["outSchool"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-outschool",
                  attrs: { index: "17" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-s-promotion" }),
                            _c("span", [_vm._v("Quản lý ra trường")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4230868766
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/group-out/student" },
                    },
                    [
                      _vm.checkPermission(["outSchool_student"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "17-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "group-out-student"
                                  )
                                },
                              },
                            },
                            [_vm._v("Học sinh\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/group-out/employee" },
                    },
                    [
                      _vm.checkPermission(["outSchool_employee"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "17-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "group-out-employee"
                                  )
                                },
                              },
                            },
                            [_vm._v("Nhân sự\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/group-out/category" },
                    },
                    [
                      _vm.checkPermission(["outSchool_folder"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "17-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "group-out-category"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thư mục\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["schoolConfig"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-config",
                  attrs: { index: "18" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-setting" }),
                            _c("span", [_vm._v("Cấu hình nhà trường")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3257342969
                  ),
                },
                [
                  _vm.checkPermission(["schoolConfig_school"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/infor" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-infor"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thông tin trường\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_absentTeacher"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/config-class" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-config-class"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình ngày nghỉ\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_attendanceEmployee"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/config-employee" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-config-employee"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình nhân sự\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_finance"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/config-common" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-config-common"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình tài chính\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["register-shift-subject"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/register-shift-subject" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "register-shift-subject"
                                  )
                                },
                              },
                            },
                            [_vm._v("Đăng ký khung giờ học\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["shift-master"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/shift-master" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "shift-master"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thiết lập khung giờ học\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_print"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/config-print" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-config-print"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình in\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_subject"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/subject" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-subject"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý môn học\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_attendanceSample"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/attendance-sample" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-9" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-attendance-sample"
                                  )
                                },
                              },
                            },
                            [_vm._v("Mẫu điểm danh\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_evaluateSample"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/evaluate-sample" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-10" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-evaluate-sample"
                                  )
                                },
                              },
                            },
                            [_vm._v("Mẫu nhận xét\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_wishSample"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/wish-sample" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-11" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-wish-sample"
                                  )
                                },
                              },
                            },
                            [_vm._v("Mẫu lời chúc\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_accountType"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/account-type" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-12" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-account-type"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý đối tượng\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkPermission(["schoolConfig_cameraSchool"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/camera-school" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-13" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-camera-school"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý camera\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/school/icon-app" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "18-14" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "icon-app-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Quản lý Icon App\n        ")]
                      ),
                    ],
                    1
                  ),
                  _vm.checkPermission(["recognition-manager"])
                    ? _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/school/recognition-manager" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "18-15" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "school-config-recognition-manager"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý nhận diện AI\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/school/chat-group" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "18-16" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod("chat-group")
                            },
                          },
                        },
                        [_vm._v("Cấu hình Chat\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-support",
              attrs: { index: "19" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-question" }),
                      _c("span", [_vm._v("Hỗ trợ & hướng dẫn")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            _vm._l(_vm.supportList, function (item) {
              return _c(
                "a",
                {
                  key: item.name,
                  staticClass: "router-link",
                  staticStyle: { color: "#bfcbd9", display: "block" },
                  attrs: { href: item.link, target: "_blank" },
                },
                [
                  _c("el-menu-item", { attrs: { index: item.name } }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }